class ShopByGoalTestimonials extends HTMLElement {
  constructor() {
    super();

    this.touchstart = null
    this.touchend = null
    this.sliding = false;

    this.activeIndex = 0;
    this.size = this.querySelectorAll('.shop-by-goal-page-testimonials__slider-item').length;

    this.querySelector('.shop-by-goal-page-testimonials__slider-arrow-left').addEventListener('click', () => {
      this.prev();
    });

    this.querySelector('.shop-by-goal-page-testimonials__slider-arrow-right').addEventListener('click', () => {
      this.next();
    });
    
    this.addEventListener('touchstart', e => {
      this.touchstart = e.changedTouches[0]
    })
    
    this.addEventListener('touchend', e => {
      this.touchend = e.changedTouches[0]
      this.checkDirection()
    })
    this.checkArrows();
  }

  prev(){
    if (this.activeIndex > 0 && !this.sliding) {
      const items = this.querySelectorAll('.shop-by-goal-page-testimonials__slider-item');
      const activeItem = items[this.activeIndex];
      const prevItem = items[this.activeIndex-1];

      activeItem.classList.add('left-out');
      prevItem.classList.add('left-in');
      this.sliding = true;
      
      setTimeout(() => {
        activeItem.classList.remove('active');
        prevItem.classList.add('active');
        prevItem.classList.remove('left-in');
        activeItem.classList.remove('left-out');
        this.sliding = false;
      }, 1100);
      
      this.activeIndex = this.activeIndex - 1;
      this.checkArrows();
    }
  }

  next(){
    if (this.size - 1 > this.activeIndex && !this.sliding) {
      const items = this.querySelectorAll('.shop-by-goal-page-testimonials__slider-item');
      const activeItem = items[this.activeIndex];
      const nextItem = items[this.activeIndex+1];

      activeItem.classList.add('right-out');
      nextItem.classList.add('right-in');
      this.sliding = true;
      
      setTimeout(() => {
        activeItem.classList.remove('active');
        nextItem.classList.add('active');
        activeItem.classList.remove('right-out');
        nextItem.classList.remove('right-in');
        this.sliding = false;
      }, 1100);

      this.activeIndex = this.activeIndex + 1;
      this.checkArrows();
    }
  }

  checkDirection() {
    if (Math.abs(this.touchend.screenY - this.touchstart.screenY) > 40 || Math.abs(this.touchend.screenX - this.touchstart.screenX) < 50) {
      this.touchend = null
      this.touchstart = null
      return;
    }
    
    if (this.touchend.screenX < this.touchstart.screenX) {
      this.next();
    }else if (this.touchend.screenX > this.touchstart.screenX) {
      this.prev();
    }

    this.touchend = null
    this.touchstart = null
  }

  checkArrows(){
    const arrows = this.querySelectorAll('.shop-by-goal-page-testimonials__slider-arrow');
    if (this.size == 1){
      arrows.forEach(arrow => {
        arrow.style.display = 'none';
      });
    }else if (this.size > 1) {
      if (this.activeIndex == 0) {
        arrows[0].style.display = 'none';
        arrows[1].style.display = 'block';
      }else if (this.activeIndex == this.size - 1) {
        arrows[0].style.display = 'block';
        arrows[1].style.display = 'none';
      }else{
        arrows[0].style.display = 'block';
        arrows[1].style.display = 'block';
      }
    }
  }

}

customElements.define('shop-by-goal-testimonials', ShopByGoalTestimonials);
